export const ACTIONS = {
  INITIALIZE_WIDGET: 'INITIALIZE_WIDGET',
  OPEN_WIDGET: 'OPEN_WIDGET',
  CLOSE_WIDGET: 'CLOSE_WIDGET',
  SET_FILTER: 'SET_FILTER',
  SET_LISTENER: 'SET_LISTENER',
  SET_DEMO: 'SET_DEMO',
  SET_TOKEN: 'SET_TOKEN',
  SET_CORS_CHECK: 'SET_CORS_CHECK',
  SET_BREADCRUMBS: 'SET_BREADCRUMBS',
  SET_HELPER_TEXT: 'SET_HELPER_TEXT',
  SET_LOCALIZATION: 'SET_LOCALIZATION',
  SET_SUBTENANTS_ENABLED: 'SET_SUBTENANTS_ENABLED',
  SET_SHOW_SUB_TENANTS_ID: 'SET_SHOW_SUB_TENANTS_ID',
  SET_MULTIPLE_SOURCES: 'SET_MULTIPLE_SOURCES',
  SET_MULTIPLE_CONNECTORS: 'SET_MULTIPLE_CONNECTORS',
  SET_MULTIPLE_TABLES: 'SET_MULTIPLE_TABLES',
  SET_ENFORCE_ONE_TO_ONE_MAPPING: 'SET_ENFORCE_ONE_TO_ONE_MAPPING',
  SET_HIDE_BACK_BUTTONS: 'SET_HIDE_BACK_BUTTONS',
  SET_CONNECT_PARAMS: 'SET_CONNECT_PARAMS',
  SET_CONNECTION_NAME: 'SET_CONNECTION_NAME',
  SET_NEXT_STEP: 'SET_NEXT_STEP',
  SET_SHOULD_DISABLE: 'SET_SHOULD_DISABLE',
  SET_HIDE_JOB_STATUS_BADGE: 'SET_HIDE_JOB_STATUS_BADGE',
  SET_CREDENTIALS_FORM_VALIDATOR: 'SET_CREDENTIALS_FORM_VALIDATOR',
  
  FETCH_PREFERENCES: 'FETCH_PREFERENCES',
  FETCH_FEATURE_FLAGS: 'FETCH_FEATURE_FLAGS',

  CLEAR_TARGETS: 'CLEAR_TARGETS',
  FETCH_SUPPORTED_TARGETS: 'FETCH_SUPPORTED_TARGETS',
  FETCH_LINKED_TARGETS: 'FETCH_LINKED_TARGETS',
  FETCH_LINKED_TARGET: 'FETCH_LINKED_TARGET',
  ADD_LINKED_TARGET: 'ADD_LINKED_TARGET',
  SELECT_TARGET: 'SELECT_TARGET',

  CLEAR_SOURCES: 'CLEAR_SOURCES',
  SELECT_SOURCE: 'SELECT_SOURCE',
  SET_CONNECTOR_PRIMARY_KEYS: 'SET_CONNECTOR_PRIMARY_KEYS',
  SET_SOURCE_PRIMARY_KEYS: 'SET_SOURCE_PRIMARY_KEYS',
  SELECT_STREAM_CONNECTOR: 'SELECT_STREAM_CONNECTOR',
  SELECT_STREAM: 'SELECT_STREAM',
  SET_FIELD_MAP: 'SET_FIELD_MAP',
  SET_FIELD_MAP_CONNECTOR: 'SET_FIELD_MAP_CONNECTOR',
  UPDATE_LINKED_SOURCE: 'UPDATE_LINKED_SOURCE',
  SET_WITH_STREAM_FIELD_MAP: 'SET_WITH_STREAM_FIELD_MAP',
  FETCH_SUPPORTED_SOURCES: 'FETCH_SUPPORTED_SOURCES',
  FETCH_LINKED_SOURCES: 'FETCH_LINKED_SOURCES',
  FETCH_LINKED_SOURCE: 'FETCH_LINKED_SOURCE',
  ADD_LINKED_SOURCE: 'ADD_LINKED_SOURCE',

  SELECT_ENTITY: 'SELECT_ENTITY',
  COPY_ENTITIES: 'COPY_ENTITIES',
  SET_IS_LINKING: 'SET_IS_LINKING',

  FETCH_SUPPORTED_FLOWS: 'FETCH_SUPPORTED_FLOWS',
  FETCH_SUPPORTED_FLOW: 'FETCH_SUPPORTED_FLOW',
  FETCH_LINKED_FLOWS: 'FETCH_LINKED_FLOWS',

  SELECT_CONNECTOR: 'SELECT_CONNECTOR',
  FETCH_SUPPORTED_CONNECTORS: 'FETCH_SUPPORTED_CONNECTORS',
  FETCH_LINKED_CONNECTORS: 'FETCH_LINKED_CONNECTORS',
  FETCH_LINKED_CONNECTOR: 'FETCH_LINKED_CONNECTOR',
  ADD_LINKED_CONNECTOR: 'ADD_LINKED_CONNECTOR',
  UNLINK_CONNECTOR: 'UNLINK_CONNECTOR',
  UPDATE_LINKED_CONNECTOR: 'UPDATE_LINKED_CONNECTOR',
  CLEAR_CONNECTORS: 'CLEAR_CONNECTORS',

  SELECT_FLOW: 'SELECT_FLOW',
  CHANGE_PAGE: 'CHANGE_PAGE',
  SET_TENANT: 'SET_TENANT',

  START_LINKING_SOURCE: 'START_LINKING_SOURCE',
  STOP_LINKING_SOURCE: 'STOP_LINKING_SOURCE',

  SET_POLLING_JOB: 'SET_POLLING_JOB',
  FETCH_LAST_JOB: 'FETCH_LAST_JOB',
  SET_ACTIVE_JOB_TYPE: 'SET_ACTIVE_JOB_TYPE',
  CLEAR_ACTIVE_JOB_TYPE: 'CLEAR_ACTIVE_JOB_TYPE',
  SET_FIELD_MAP_SELECTION: 'SET_FIELD_MAP_SELECTION',
  SET_FIELD_MAP_SELECTION_CONNECTOR: 'SET_FIELD_MAP_SELECTION_CONNECTOR',
  CLEAR_FIELD_MAP_SELECTION: 'CLEAR_FIELD_MAP_SELECTION',
  CLEAR_FIELD_MAP_SELECTION_CONNECTOR: 'CLEAR_FIELD_MAP_SELECTION_CONNECTOR',

  SET_DIALOG_SIZE: 'SET_DIALOG_SIZE',
  SET_WIDTH: 'SET_WIDTH',
  SET_HEIGHT: 'SET_HEIGHT',
  SET_IS_CONNECTION: 'SET_IS_CONNECTION',
  SET_HIDE_FLOWS: 'SET_HIDE_FLOWS',
  SET_OPERATION: 'SET_OPERATION',

  UPDATE_TENANT_MAPPING: 'UPDATE_TENANT_MAPPING',
  FETCH_TENANT_MAPPING: 'FETCH_TENANT_MAPPING',
  SET_SCHEMA: 'SET_SCHEMA',
  ADD_SCHEMA_TABLE: 'ADD_SCHEMA_TABLE',
  LOAD_MAPPING: 'LOAD_MAPPING'
};
